<script setup lang="ts">
import {ExtendedProject, Role, Subscription} from "@/types";
import BaseLayout from "@/layouts/BaseLayout.vue";
import ProjectLayout from "@/Pages/projects/layouts/ProjectLayout.vue";
import {route} from "ziggy-js";
import {Head, router} from "@inertiajs/vue3";
import SubscriptionsList from "@/Pages/projects/active_subscriptions/components/SubscriptionsList.vue";

interface Props {
  project: ExtendedProject,
  role: Role,
  subscriptions: Array<Subscription>
}

const props = defineProps<Props>()
defineOptions({
    layout: BaseLayout
})
</script>

<template>
    <Head title="Configure email notifications" />
    <project-layout
        :role="props.role"
        :project="props.project"
    >
        <h1 class="font-weight-medium text-h5 mt-5">
            Email notifications
        </h1>
        <v-divider class="my-3" />
        <v-card
            :flat="true"
            class="mb-5"
        >
            <v-card-text>
                <v-row>
                    <span class="text-h5 black--text">Manage subscriptions</span>
                    <v-spacer />
                    <default-btn
                        size="small"
                        class="border font-weight-medium mr-2"
                        rounded="lg"
                        @click="router.visit(route('projects.subscriptions.create', {project: props.project.slug}))"
                    >
                        Add a subscriber
                    </default-btn>
                </v-row>
                <v-row>
                    <v-col
                        cols="12"
                        class="px-0"
                    >
                        <p>
                            Subscriptions allows you to easily be notified when an transfer event is triggered.
                        </p>
                        <subscriptions-list
                            :subscriptions="props.subscriptions"
                            :project="props.project"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </project-layout>
</template>

<style scoped>

</style>
